import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "desktop" }
const _hoisted_2 = ["src"]

import { computed } from 'vue';
import { Row, Col } from 'ant-design-vue';
import unipuslogo from '@/assets/img/logo.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'PCHeader',
  props: {
  appKey: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

// 全语用自己的logo，其他都用unipus的默认logo
const currentLogo = computed(() => {
  if (props.appKey === 'quanyu') {
    return unipuslogo;
  }
  return unipuslogo;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Row), {
      align: "middle",
      class: "content"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), null, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: currentLogo.value,
              class: "logo"
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), null, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "text" }, "收银台", -1)
          ])),
          _: 1,
          __: [0]
        })
      ]),
      _: 1
    })
  ]))
}
}

})